import { LOGO_THEME } from "../../constants/logo";
import FormContainer from "./FormContainer/FormContainer";
import Logo from "../UI/Logo/Logo";

const Login = () => {
  return (
    <div className="flex">
      <div className="bg-dark-blue relative w-1/4 hidden lg:block">
        <div className="flex justify-center mt-12">
          <Logo theme={LOGO_THEME.WHITE} />
        </div>
        <div className="absolute bottom-4 right-0 w-500 h-80 bg-mechanic-car bg-no-repeat bg-right bg-contain" />
      </div>
      <div className="relative z-10 w-full lg:w-3/4 h-screen">
        <FormContainer />
      </div>
    </div>
  );
};

export default Login;
